<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-6 searching">
                        <span class="h_page">Indikator Tujuan Pembangunan</span> <br> <br>
                    </div>
                    <div class="col-md-3">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
                <br>
                <div class="row">

                    <div class="col-md-6">
                        <span class="huruf_input">Periode RPJMD</span>
                        <select class="form-control show-tick" v-model="rpjmd_id" @change="getMisi">
                            <option value="" >-- Semua Periode --</option>
                            <option v-for="data in list_RPJMD" :key="data.rpjmd_id" :value="data.rpjmd_id">{{data.periode}}</option>
                        </select>
                    </div>

                    <div class="col-md-6">
                        <span class="huruf_input">Misi</span>
                        <select class="form-control show-tick" v-model="misi_id" @change="getTujuan">
                            <option value="" >-- Semua Misi --</option>
                            <option v-for="data in list_misi" :key="data.misi_id" :value="data.misi_id">[{{data.no_misi}}] {{data.uraian}}</option>
                        </select>
                    </div>
                </div>
                <br>
        <!-- ============================================================ MULAI ======================================================================== -->

                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-success kepala_table_f tabel_center">
                            <th class="text-center" style="width: 5%">Kode</th>
                            <th class="text-center" style="width: 40%">Indikator</th>
                            <th class="text-center" style="width: 8%">Satuan</th>
                            <th class="text-center" style="width: 15%">Rumusan Satuan</th>
                            <th class="text-center" style="width: 10%">Capaian Awal</th>
                            <th class="text-center" style="width: 10%" >Kondisi Akhir</th>
                            <th class="text-center" style="width: 12%">#</th>
                        </tr>
                        </thead>
                        <tbody class="tabel_center" >
                          <tr class="h_isitable" v-for="data in list_data" :key="data.indikator_id">
                            <td class="tabel_center text-center">{{data.no_misi}}.{{data.no_tujuan}}.{{data.no_indikator}}</td>
                            <td class="tabel_center" >{{data.uraian}}</td>
                            <td class="tabel_center text-center">{{data.satuan}}</td>
                            <td class="tabel_center text-center" >{{data.rumus_satuan}}</td>
                            <td class="tabel_center text-center" >{{data.capaian_awal}}</td>
                            <td class="tabel_center text-center" >{{data.kondisi_akhir}}</td>
                            <td class="tabel_center text-center" >

                                <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                    <i class="material-icons" >create</i>
                                </button>
                                &nbsp;
                                <button @click="removeData(data.indikator_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                    <i class="material-icons" >clear</i>
                                </button>

                            </td>
                          </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                    <div class="text-center">
                        <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                            <i class="material-icons">skip_previous</i>
                        </button>
                        &nbsp;
                        <span style="font-size: 85%; color: #a5a5a5">
                            <b>{{page_first}} - {{page_last}}</b>
                        </span>
                        &nbsp;
                        <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                            <i class="material-icons">skip_next</i>
                        </button>
                    </div>
                <hr>
                <!-- ============================================================ MODAL ======================================================================== -->


                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-blue">
                                        <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span></button>
                                        <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                    </div>

                                <form @submit.prevent="addData()">

                                    <div class="modal-body">
                                        <div v-if="!check_misi" class="alert alert-info text-center">
                                            <strong>SILAHKAN PILIH PERIODE RPJMD DAN MISI TERLEBIH DAHULU!</strong> 
                                        </div>

                                        <div v-if="check_misi">

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Tujuan Pemb.</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                    <div class="form-line">
                                                        <select class="form-control" v-model="tujuan_id">
                                                            <option v-for="data in list_tujuan" :key="data.tujuan_id" :value="data.tujuan_id">{{data.uraian}}</option>
                                                        </select>
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">No</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="no_indikator" :required="true" type="text" class="form-control" placeholder="Ex : 1">
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Uraian</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="uraian" :required="true" type="text" class="form-control">
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Satuan</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="satuan" :required="true" type="text" class="form-control">
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Rumusan Satuan</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="rumus_satuan" :required="true" type="text" class="form-control">
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Capaian Awal</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="capaian_awal" :required="true" type="text" class="form-control" placeholder="Ex : 1">
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Kondisi Akhir</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="kondisi_akhir" :required="true" type="text" class="form-control" placeholder="Ex : 5">
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="modal-footer">
                                        <button v-if="check_misi" type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                        <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </form>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-green">
                                        <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span></button>
                                        <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                    </div>
                                <form @submit.prevent="editData()">
                                    <div class="modal-body">
                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Periode RPJMD</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                <div class="form-line">
                                                    <select class="form-control show-tick" v-model="rpjmd_id" @change="getMisi">
                                                        <option v-for="data in list_RPJMD" :key="data.rpjmd_id" :value="data.rpjmd_id">{{data.periode}}</option>
                                                    </select>
                                                </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Misi</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                <div class="form-line">
                                                    <select class="form-control show-tick" v-model="misi_id" @change="getTujuan">
                                                        <option v-for="data in list_misi" :key="data.misi_id" :value="data.misi_id">{{data.uraian}}</option>
                                                    </select>
                                                </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Tujuan Pemb.</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                <div class="form-line">
                                                    <select class="form-control" v-model="tujuan_id">
                                                        <option v-for="data in list_tujuan" :key="data.tujuan_id" :value="data.tujuan_id">{{data.uraian}}</option>
                                                    </select>
                                                </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">No</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="no_indikator" :required="true" type="text" class="form-control" placeholder="Ex : 1">
                                                </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Uraian</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="uraian" :required="true" type="text" class="form-control">
                                                </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Satuan</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="satuan" :required="true" type="text" class="form-control">
                                                </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Rumusan Satuan</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="rumus_satuan" :required="true" type="text" class="form-control">
                                                </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Capaian Awal</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="capaian_awal" :required="true" type="text" class="form-control" placeholder="Ex : 1">
                                                </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Kondisi Akhir</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="kondisi_akhir" :required="true" type="text" class="form-control" placeholder="Ex : 5">
                                                </div>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                        <button @click="emptyData()"  type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </form>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- ============================================================ MODAL ======================================================================== -->




        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/planning_indikator_tujuan_pembangunan/';
    const ADD_URL_RPJMD = URL_APP+'api/v1/planning_rpjmd/';
    const ADD_URL_MISI = URL_APP+'api/v1/planning_misi/';
    const ADD_URL_TUJUAN = URL_APP+'api/v1/planning_tujuan/';


    export default {
        name: "planning_rpjmd",
        data() {
            return {

                rpjmd_id : '',
                misi_id : '',
                tujuan_id : '',
                
                indikator_id: '',
                no_indikator : '',
                uraian : '',
                satuan : '',
                rumus_satuan : '',
                capaian_awal : '',
                kondisi_akhir : '',

                check_misi : false,


                list_RPJMD : [],
                list_misi : [],
                list_tujuan : [],

                list_data: [],
                page_first : 1,
                page_last : 0,
                cari_value : ''
            };
        },

        mounted() {
            this.getRPJMD();
            this.getData();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){

                console.log('RPJMD :'+this.rpjmd_id);
                console.log('MISI :'+this.misi_id);

                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({
                        tujuan_id : this.tujuan_id,
                        no_indikator : this.no_indikator,
                        uraian : this.uraian,
                        satuan : this.satuan,
                        rumus_satuan : this.rumus_satuan,
                        capaian_awal : this.capaian_awal,
                        kondisi_akhir : this.kondisi_akhir,
                    })
                }).then(res => res.json()).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value,
                      rpjmd_id : this.rpjmd_id,
                      misi_id : this.misi_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_data = res_data.data;
                  this.page_last = res_data.jml_data;
                //   console.log(res_data);
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        indikator_id : this.indikator_id,
                        tujuan_id : this.tujuan_id,
                        no_indikator : this.no_indikator,
                        uraian : this.uraian,
                        satuan : this.satuan,
                        rumus_satuan : this.rumus_satuan,
                        capaian_awal : this.capaian_awal,
                        kondisi_akhir : this.kondisi_akhir,
                    })
                }).then((res_data) => {
                  console.log(res_data);
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(data){
                this.rpjmd_id = data.rpjmd_id;
                this.misi_id = data.misi_id;
                this.tujuan_id = data.tujuan_id;
                
                this.indikator_id = data.indikator_id;
                this.no_indikator = data.no_indikator;
                this.uraian = data.uraian;
                this.satuan = data.satuan;
                this.rumus_satuan = data.rumus_satuan;
                this.capaian_awal = data.capaian_awal;
                this.kondisi_akhir = data.kondisi_akhir;
                this.getMisi();
                this.getTujuan();
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          indikator_id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                // this.rpjmd_id = '';
                // this.misi_id = '';
                // this.tujuan_id = '';
                // this.indikator_id = '';
                // this.no_indikator = '';
                // this.uraian = '';
                // this.satuan = '';
                // this.rumus_satuan = '';
                // this.capaian_awal = '';
                // this.kondisi_akhir = '';
                // this.getData();
            },

            //TAMBAHAN
            getRPJMD : function(){
                fetch(ADD_URL_RPJMD, {
                    method : 'GET',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    }
                }).then(res => res.json()).then((res_data)=>{
                    this.list_RPJMD = res_data;
                    this.getData()
                    // console.log(res_data);
                })
            },
            getMisi : function(){
                if (this.rpjmd_id == '') { this.misi_id =''} // Agar ketika pilih Periode RPJMD = 'semua periode' maka semua data akan tampil
                fetch(ADD_URL_MISI+'misi_id_rpjmd', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara '+localStorage.token
                    },
                    body : JSON.stringify({
                        rpjmd_id : this.rpjmd_id
                    })
                }).then(res => res.json()).then((res_data)=>{
                    this.list_misi = res_data;
                    this.getData();
                    // console.log(res_data);
                })
            },
            getTujuan : function(){
                console.log(this.misi_id);

                if (this.misi_id == '') {this.check_misi = false; this.getData();} 
                else {
                    this.check_misi = true;
                    fetch(ADD_URL_TUJUAN+'tujuan_id_misi', {
                        method : 'POST',
                        headers : {
                            'content-type' : 'application/json',
                            authorization : 'kikensbatara '+localStorage.token
                        },
                        body : JSON.stringify({misi_id : this.misi_id})
                    }).then(res => res.json()).then((res_data)=>{
                        this.list_tujuan = res_data;
                        this.getData();
                        // console.log(res_data);
                    })
                }
            },
            //TAMBAHAN

            //PAGINASI
                alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
                },

                btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
                },

                btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
                },

                cari_data : function(){
                this.getData();
                }
            //PAGINASI
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
